var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.type,"size":_vm.size,"outlined":_vm.outlined,"disabled":_vm.saving || _vm.period.closed_at,"loading":_vm.saving,"expanded":""},on:{"click":_vm.save}},[_c('span',{staticClass:"is-size-7"},[_vm._v(_vm._s((_vm.period.closed_at) ? 'Period Closed' : 'Add Time'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }